import React, { useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import SettingsIcon from "@mui/icons-material/Settings";
import { changeTheme } from "../../../redux/langauge/actions"; // Adjust according to your file structure

const ThemeSubMenu = ({ anchorEl, open, handleClose }) => {
  const dispatch = useDispatch();
  const [theme, setTheme] = useState("system");

  useLayoutEffect(() => {
    // to set the active option in the theme pop up
    const localStorageTheme = localStorage.getItem("theme");
    setTheme(localStorageTheme);
  }, []);

  const handleMenuItemClick = (mode) => (e) => {
    setTheme(mode);
    dispatch(changeTheme(mode));
    handleClose(e);
  };

  return (
    <Menu
      id="theme-submenu"
      anchorEl={anchorEl}
      open={open}
      sx={{
        marginLeft: "30px",
        top: "-30px",
      }}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            bottom: 10,
            left: -5,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-45%) rotate(-45deg)",
            zIndex: 0,
          },
        },
      }}
    >
      <MenuItem onClick={handleMenuItemClick("system")} selected={theme === "system"}>
        <ListItemIcon>
          <SettingsIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Match device" secondary="Use the same theme as your device" />
      </MenuItem>
      <MenuItem onClick={handleMenuItemClick("light")} selected={theme === "light"}>
        <ListItemIcon>
          <LightModeIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Light mode" secondary="Light background with dark text" />
      </MenuItem>
      <MenuItem onClick={handleMenuItemClick("dark")} selected={theme === "dark"}>
        <ListItemIcon>
          <DarkModeIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Dark mode" secondary="Dark background with light text" />
      </MenuItem>
    </Menu>
  );
};

export default ThemeSubMenu;
